import React from 'react';
import {
  Menu as MuiMenu,
  MenuItem,
  Typography,
  Box,
  Divider,
  ListItemIcon,
  ListItemText,
  Avatar,
  Skeleton,
} from '@mui/material';
import { CheckCircle, Business } from '@mui/icons-material';

export function CompanySwitchMenu({
  anchorEl,
  openMenu,
  handleCloseCompanies,
  companies = [],
  handleSwitchCompany,
  loading = false, // 👈 nueva prop opcional
}) {
  // Función auxiliar para obtener las iniciales del nombre de la compañía
  const getInitials = (name) => {
    return (
      (name || '')
        .split(' ')
        .map((s) => s?.[0])
        .filter(Boolean)
        .slice(0, 2)
        .join('')
        .toUpperCase() || 'E'
    );
  };

  return (
    <MuiMenu
      anchorEl={anchorEl}
      open={openMenu}
      onClose={handleCloseCompanies}
      PaperProps={{
        sx: {
          minWidth: 250,
          maxWidth: 300,
          borderRadius: '12px',
          boxShadow: '0px 8px 24px rgba(0, 0, 0, 0.15)',
          p: 1,
        },
      }}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
    >
      {/* Encabezado */}
      <Box sx={{ px: 2, py: 1.5 }}>
        <Typography
          variant="subtitle2"
          color="text.secondary"
          sx={{ fontWeight: 600 }}
        >
          Cambiar Empresa Activa
        </Typography>
      </Box>
      <Divider sx={{ mb: 1 }} />

      {/* Skeletons mientras carga */}
      {loading && (
        <>
          {[1, 2, 3].map((idx) => (
            <MenuItem key={idx} sx={{ borderRadius: '8px', mb: 0.5 }}>
              <ListItemIcon sx={{ minWidth: 40 }}>
                <Skeleton variant="circular" width={24} height={24} />
              </ListItemIcon>
              <ListItemText
                primary={
                  <Skeleton
                    variant="text"
                    width={140}
                    sx={{ fontSize: '0.9rem' }}
                  />
                }
              />
              <Skeleton variant="circular" width={18} height={18} />
            </MenuItem>
          ))}
        </>
      )}

      {/* Sin empresas (solo si NO está cargando) */}
      {!loading && companies.length === 0 && (
        <MenuItem disabled>
          <ListItemIcon>
            <Business fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="(Sin empresas disponibles)" />
        </MenuItem>
      )}

      {/* Lista real de empresas (solo si NO está cargando) */}
      {!loading &&
        companies.map((c) => {
          const isCurrent = !!c.current;
          const displayName = c.label || c.name;
          return (
            <MenuItem
              key={c.id}
              selected={isCurrent}
              onClick={() => handleSwitchCompany(c.id)}
              sx={{
                borderRadius: '8px',
                mb: 0.5,
                ...(isCurrent && {
                  backgroundColor: 'primary.light',
                  '&:hover': {
                    backgroundColor: 'primary.light',
                  },
                }),
              }}
            >
              <ListItemIcon sx={{ minWidth: 40 }}>
                <Avatar
                  sx={{
                    width: 24,
                    height: 24,
                    bgcolor: isCurrent ? 'primary.main' : 'grey.400',
                    fontSize: 12,
                    fontWeight: 700,
                  }}
                >
                  {getInitials(displayName)}
                </Avatar>
              </ListItemIcon>

              <ListItemText
                primary={
                  <Typography sx={{ fontWeight: isCurrent ? 700 : 500 }}>
                    {displayName}
                  </Typography>
                }
              />

              {isCurrent && <CheckCircle fontSize="small" color="primary" />}
            </MenuItem>
          );
        })}
    </MuiMenu>
  );
}
